var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"home-container p-0",attrs:{"fluid":""}},[_c('NavBar'),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }